import { Download, Share, SquarePlus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useInstallPrompt } from "@/lib/pwa/useInstallPrompt";

/**
 * Dezenter Hinweis, die Plattform als App zu installieren.
 *
 * Erscheint auf allen Routen — auch auf /login, was der natürliche Moment für
 * eine Installation ist — und lässt sich dauerhaft wegklicken.
 */
export function InstallPrompt() {
  const { mode, install, dismiss } = useInstallPrompt();

  if (mode === "hidden") return null;

  return (
    <div
      className="fixed right-4 bottom-4 left-4 z-50 flex justify-end max-sm:justify-center"
      role="complementary"
      aria-label="App installieren"
    >
      <Card size="sm" className="w-full max-w-sm shadow-lg">
        <CardContent className="flex items-start gap-3">
          <img src="/app-icon.svg" alt="" width={40} height={40} className="mt-0.5 size-10 shrink-0 rounded-lg" />
          <div className="min-w-0 flex-1">
            <p className="font-medium text-foreground">Als App installieren</p>
            {mode === "prompt" ? (
              <>
                <p className="mt-0.5 text-muted-foreground">
                  Die Onboarding-Plattform im eigenen Fenster öffnen – ohne Adressleiste, direkt
                  vom Dock oder Startbildschirm.
                </p>
                <Button className="mt-3" onClick={() => void install()}>
                  <Download aria-hidden="true" />
                  App installieren
                </Button>
              </>
            ) : (
              <p className="mt-0.5 text-muted-foreground">
                In Safari auf <Share aria-hidden="true" className="inline size-4 align-text-bottom" />{" "}
                <span className="font-medium text-foreground">Teilen</span> tippen und dann{" "}
                <SquarePlus aria-hidden="true" className="inline size-4 align-text-bottom" />{" "}
                <span className="font-medium text-foreground">Zum Home-Bildschirm</span> wählen.
              </p>
            )}
          </div>
          <Button variant="ghost" size="icon-sm" onClick={dismiss} aria-label="Hinweis ausblenden">
            <X aria-hidden="true" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
